import React, { useEffect, useState } from "react";
import useHttpHook from "../../../Hooks/HttpHook";
import { CountriesList, CategoriesList } from "../../../utils/ApiConstant";
import Input from "../../UiElement/FormElement/Input";
import { useForm } from "react-hook-form";
import ModalWrapper from "../../Common/Portals/ModalWrapper";
import MainComponentWrapper from "../../Common/MainComponentWrapper";
import { EventLanguage } from "../../../utils/Languages";

const EventFilterModal = (props) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
  } = useForm();
  const [loading, sendRequest, error] = useHttpHook();
  const [countries, setCountriesList] = useState();
  const [categories, setCategoriesList] = useState();
  const [country, setCountry] = useState("");
  const [category, setCategory] = useState("");

  useEffect(() => {
    getCountries();
    getCategories();
  }, []);
  const getCountries = async () => {
    let countriesList = await sendRequest(CountriesList, { method: "get" });
    setCountriesList(countriesList.data);
  };

  const getCategories = async () => {
    let categoriesList = await sendRequest(CategoriesList, { method: "get" });
    setCategoriesList(categoriesList.data);
  };

  const onSubmit = async (data) => {
    // if (data.startDate > data.endDate) {
    //     alert('Start date should be less than end date')
    //     return
    // }
    let events = await sendRequest(props.eventURL, { method: "post", data });
    if (events.status === 1) {
      props.setEventsList(events);
      props.CloseModalHandler();
    }
  };

  return (
    <MainComponentWrapper Loading={loading} errorInfo={error}>
      <ModalWrapper
        title="Search"
        submitText="Search"
        CloseModalHandler={props.CloseModalHandler}
        formId="event-filter"
      >
        <form
          className="row"
          id="event-filter"
          onSubmit={handleSubmit(onSubmit)}
        >
          <Input
            element="select"
            WrapperClass="input col-lg-6 col-md-12"
            Label={EventLanguage.UserEvents.filter.Location}
            FieldName="country"
            options={countries}
            optionValue="name"
            optionLabel="name"
            Register={register}
            Errors={errors}
            showInputValue={true}
            clickHandler={(e) => setCountry(e.target.value)}
            defValue={country}
          />
          <Input
            element="text"
            WrapperClass="input col-lg-6 col-md-12"
            Label={EventLanguage.UserEvents.filter.City}
            FieldName="city"
            placeholder="Enter City"
            Register={register}
            Errors={errors}
          />
          <Input
            element="select"
            WrapperClass="input col-12"
            Label={EventLanguage.UserEvents.filter.Category}
            FieldName="category"
            // defValue=""
            options={categories}
            optionValue="category"
            optionLabel="category"
            Register={register}
            Errors={errors}
            clickHandler={(e) => setCategory(e.target.value)}
            defValue={category}
          />
          <Input
            element="date"
            WrapperClass="input col-lg-6 col-md-12"
            Label={EventLanguage.UserEvents.filter.StartDate}
            FieldName="startDate"
            Register={register}
            Errors={errors}
          />
          <Input
            element="date"
            WrapperClass="input col-lg-6 col-md-12"
            Label={EventLanguage.UserEvents.filter.EndDate}
            FieldName="endDate"
            Register={register}
            Errors={errors}
          />
        </form>
      </ModalWrapper>
    </MainComponentWrapper>
  );
};
export default EventFilterModal;
